import script from "./AcceptInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&setup=true&lang=js"

import "./AcceptInvite.vue?vue&type=style&index=0&id=11b7294d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b7294d"]])

export default __exports__